import { Component, OnInit, ViewChild } from '@angular/core';
import { ApiService } from '../../../services/main/api.service';
import { NgbModal, ModalDismissReasons, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import Swal from 'sweetalert2';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Storage } from '@ionic/storage';
import { Router, ActivatedRoute } from '@angular/router';
import { Global } from '../../../services/global';
import { BaseCrudComponent } from '../../base-crud/base-crud.component';
import { TranslateService } from '@ngx-translate/core';
import { Observable, BehaviorSubject, of, throwError, from } from 'rxjs';
import { mergeMap, catchError, timeout, retry } from 'rxjs/operators';
import { ExportAsService, ExportAsConfig } from 'ngx-export-as';
import * as moment from 'moment-timezone';

import { LazyLoadEvent } from 'primeng/api';
import { SelectItem } from 'primeng/api';
import {MessageService} from 'primeng/api';

import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';

@Component({
  selector: 'app-routeaccomplish',
  templateUrl: './routeaccomplish.component.html',
  styleUrls: ['./routeaccomplish.component.css']
})
export class RouteaccomplishComponent extends BaseCrudComponent {

	exportAsConfig: ExportAsConfig = {
	    type: 'xlsx',
	    elementIdOrContent: 'exportable'
	};

	translations:any;
	header:any;
	momentjs: any = moment;
    curr_date:any;
    today:any;
    dstart:any;
    dend:any;
    zones:any;
    route_in:any;
    route_out:any;
    totals_in:any;
    totals_out:any;
    totals_day:any;
    sum_sales:any;
    sum_pay:any;
    client_kpi_1:any;
    client_kpi_2:any;
    client_kpi_3:any;
    client_kpi_4:any;
    client_kpi_5:any;

    frozenCols:any;

	constructor(
	    srv: ApiService,
	    modalService: NgbModal,
	    storage: Storage,
  		router: Router,
  		private route: ActivatedRoute,
        public translate: TranslateService,
        private exportAsService: ExportAsService
	  ) {
	    super(srv, modalService, storage, router);
	    this.read_url = 'ReportRouteGoal/Post';
        this.header = {};
        this.zones = [];
        this.route_in = [];
        this.route_out = [];
        this.totals_in = [];
	    this.totals_out = [];
	    this.totals_day = [];
	    this.sum_sales = [];
	    this.sum_pay = [];
	    this.client_kpi_1 = [];
	    this.client_kpi_2 = [];
	    this.client_kpi_3 = [];
	    this.client_kpi_4 = [];
        this.client_kpi_5 = [];

        this.frozenCols = [
            { field: 'orden', header: 'orden' }
        ];
    }

    ngOnInit() {
        this.curr_date = this.momentjs().tz('America/Guayaquil').format('YYYY-MM-DD');
        this.today = this.momentjs().tz('America/Guayaquil').format('YYYY-MM-DD');
        this.f_datefrom = this.curr_date;

    	this.translate.getTranslation(this.translate.currentLang)
        .subscribe((translations) => {
              this.translations = translations;
              super.ngOnInit();
              this.getList();
        });

        this.getZonesData().subscribe(x => {
            if(x != false){
                this.zones = x;
            }
        });
    }

    clearData(){
        this.header = {};
        this.route_in = [];
        this.route_out = [];
        this.totals_in = [];
        this.totals_out = [];
        this.totals_day = [];
        this.sum_sales = [];
        this.sum_pay = [];
        this.client_kpi_1 = [];
        this.client_kpi_2 = [];
        this.client_kpi_3 = [];
        this.client_kpi_4 = [];
        this.client_kpi_5 = [];
    }

    public getList(){
        var qst = this.read_url;
        var obj:any;
        //this.f_datefrom = '2020-10-01';
        this.clearData();

        obj = {
            Zone: null,
            Date: this.f_datefrom
        }

        if( (this.f_custom1 != null) && (this.f_custom1 != 'null') ){
        	obj.Zone = this.f_custom1;
        }

        this.loadingList = true;
        //console.log(obj);

        this.srv.postCall(qst, obj).subscribe(x => {
        	this.loadingList = false;

            if(x.status){
                var rs = x.data;
                this.header = rs.header;
                this.totals_day = rs.totalDays;
                this.route_in = rs.detail.routeIn;
                this.totals_in = rs.detail.totalsRouteIn;
                this.route_out = rs.detail.routeOut;
                this.totals_out = rs.detail.totalsRouteOut;
                this.sum_sales = rs.detail.salesSummary;
                this.sum_pay = rs.detail.collectionSummary;
                this.client_kpi_1 = rs.detail.clienteIndicatorsFirst;
                this.client_kpi_2 = rs.detail.clienteIndicatorsSecond;
                this.client_kpi_3 = rs.detail.clienteIndicatorsThird;
                this.client_kpi_4 = rs.detail.clienteIndicatorsFourth;
                this.client_kpi_5 = rs.detail.clienteIndicatorsFifth;
            }
        });
    }

    public getZonesData(){
        var par_url = 'ZoneBP/ListByUser';

        return this.srv.getCall(par_url).pipe(
                    mergeMap(data => {
                        let mydata:any = {status: false, data: [], message: ''};
                        mydata = data;
                        //console.log(data);
                        
                        if( mydata.status ){
                          return of(mydata.data);
                        }
                        else{
                          return of(false);
                        }
                      }),
                      //timeout(MAX_TIME),
                      catchError(data => {return of(false)})
                );
    }

    getPdfReportHeader(){
        var obj = [];

        obj.push([{content:'REPORTE  CUMPLIMIENTO CON OBJETIVOS DEL DIA (VENDEDOR)', colSpan:4, styles:{fontStyle:'bold', halign:'center'}}]);
        obj.push([
            {content:'Vendedor: ' + this.header['agent'], colSpan:2},
            {content:'Fecha: ' + this.curr_date, colSpan:2}
        ]);
        obj.push([
            {content:'Supervisor: ' + this.header['supervisor'], colSpan:2},
            {content:'', colSpan:2}
        ]);

        return obj;
    }

    exportReport(){
        var doc = new jsPDF('l','pt', 'a4');
        autoTable(doc, {body: this.getPdfReportHeader(), theme:'grid'});

        let header = [];
        let header_kpis = [['ITEM', 'EN RUTA', 'FUERA DE RUTA', 'TOTAL']];
        let footer = [];
        let x = [];

        //Route In
        header = [];
        header.push([{content:'CLIENTES EN RUTA', colSpan:16, styles:{fontStyle:'bold', halign:'center', fontSize:10}}]);
        header.push(['No', 'CODIGO', 'NOMBRE 1', 'CIUDAD', 'ABC', 'H. INICIO', 'H. FIN', 'T. VISITA', 'T. INACTIVO', 'Ped Vend', 'Cotización', 'Cobro', 'Obs. No Venta', 'Obs. No Cobros']);
        
        x = [];
        this.route_in.forEach(i => {
            x.push([
                i.orden,
                i.idCliente,
                i.nombreCliente,
                i.ciudad,
                i.claseAbc,
                i.hinicio,
                i.hfin,
                i.sTvisita,
                i.tinactividad,
                {content:'$'+i.venta, styles:{halign:'right'}},
                {content:'$'+i.cotizacion, styles:{halign:'right'}},
                // {content:'$'+i.objCobro, styles:{halign:'right'}},
                {content:'$'+i.cobro, styles:{halign:'right'}},
                i.obsNoVenta,
                i.obsNoCobro,
                // i.rango
            ]);
        });

        footer = [];
        footer.push([
            {content:'TOTAL EN RUTA', colSpan:7, styles:{halign:'left'}},
            {content:this.totals_in.visit, styles:{halign:'center'}},
            {content:this.totals_in.inactive, styles:{halign:'center'}},
            '$'+this.totals_in.sales,
            '',
            // '$'+this.totals_in.collectGoal,
            '$'+this.totals_in.collect,
            '',
            ''
            //, ''
        ]);

        autoTable(doc, {head:header, body: x, foot: footer, headStyles:{fontSize:7, fillColor:'#3e5569', halign:'center'}, bodyStyles:{fontSize:7, halign:'center'}, footStyles:{fontSize:7, fillColor:'#e9ecef', textColor:'#000', halign:'right'}});

        //Route Out
        header = [];
        header.push([{content:'CLIENTES FUERA DE RUTA', colSpan:16, styles:{fontStyle:'bold', halign:'center', fontSize:10}}]);
        header.push(['No', 'CODIGO', 'NOMBRE 1', 'CIUDAD', 'ABC', 'H. INICIO', 'H. FIN', 'T. VISITA', 'T. INACTIVO', 'Ped Vend', 'Cotización', 'Cobro', 'Obs. No Venta', 'Obs. No Cobros']);
        x = [];
        this.route_out.forEach(i => {
            x.push([
                i.orden,
                i.idCliente,
                i.nombreCliente,
                i.ciudad,
                i.claseAbc,
                i.hinicio,
                i.hfin,
                i.sTvisita,
                i.tinactividad,
                {content: '$'+i.venta, styles:{halign:'right'}},
                {content: '$'+i.cotizacion, styles:{halign:'right'}},
                // {content: '$'+i.objCobro, styles:{halign:'right'}},
                {content: '$'+i.cobro, styles:{halign:'right'}},
                i.obsNoVenta,
                i.obsNoCobro
                //, i.rango
            ]);
        });

        footer = [];
        footer.push([
            {content:'TOTAL FUERA DE RUTA', colSpan:7, styles:{halign:'left'}},
            {content:this.totals_out.visit, styles:{halign:'center'}},
            {content:this.totals_out.inactive, styles:{halign:'center'}},
            '$'+this.totals_out.sales,
            '',
            // '$'+this.totals_out.collectGoal,
            '$'+this.totals_out.collect,
            '',
            ''
            // ,''
        ]);

        autoTable(doc, {head:header, body: x, foot: footer, headStyles:{fontSize:7, halign:'center'}, bodyStyles:{fontSize:7, halign:'center'}, footStyles:{fontSize:7, fillColor:'#e9ecef', textColor:'#000', halign:'right'}});

        //Day totals
        header = [];
        header.push(['', 'T. VISITA', 'T. INACTIVO', 'Ped Vend', 'Cobro']);

        footer = [];
        footer.push([
            'TOTAL DIA',
            this.totals_day.visit,
            this.totals_day.inactive,
            '$'+this.totals_day.sales,
            // '$'+this.totals_day.collectGoal,
            '$'+this.totals_day.collect
        ]);

        autoTable(doc, {head:header, foot: footer, headStyles:{fontSize:10, halign:'center'}, footStyles:{fontSize:10, fillColor:'#e9ecef', textColor:'#000', halign:'center'}});

        //KPI 1
        x = [];
        x.push(['Pedidos Realizados $', '$ '+this.sum_sales.salesRealInRoute, '$ '+this.sum_sales.salesRealOutRoute, '$ '+this.sum_sales.salesRealTotal]);
        x.push(['Venta Obj. Día', '$ '+this.sum_sales.salesGoalDayInRoute, '$ '+this.sum_sales.salesGoalDayOutRoute, '$ '+this.sum_sales.salesGoalDayTotal]);

        footer = [];
        footer.push([
            {content:'% Cumplimiento con Objetivo de Ventas del Día', colSpan:3},
            this.sum_sales.goalPercent
        ]);

        autoTable(doc, {head:header_kpis, body:x, foot: footer, headStyles:{fillColor:'#e9ecef', textColor:'#000'}, footStyles:{fillColor:'#e9ecef', textColor:'#000'}, theme:'grid'});

        //KPI 2
        x = [];
        x.push(['Cobro Real', '$ '+this.sum_pay.collectReal_InRoute, '$ '+this.sum_pay.collectReal_OutRoute, '$ '+this.sum_pay.collectReal_Total]);
        // x.push(['Cobro Obj. ', '$ '+this.sum_pay.collectGoalDay_InRoute, '$ '+this.sum_pay.collectGoalDay_OutRoute, '$ '+this.sum_pay.collectGoalDay_Total]);

        footer = [];
        // footer.push([
        //     {content:'% Cumplimiento con Objetivo de Cobros del Día', colSpan:3},
        //     this.sum_pay.percent
        // ]);

        autoTable(doc, {head:header_kpis, body:x, foot: footer, headStyles:{fillColor:'#e9ecef', textColor:'#000'}, footStyles:{fillColor:'#e9ecef', textColor:'#000'}, theme:'grid'});

        //KPI 3
        x = [];
        x.push(['Clientes Planificados', this.client_kpi_1.plannedClients_InRoute, this.client_kpi_1.plannedClients_OutRoute, this.client_kpi_1.plannedClients_Total]);
        x.push(['Clientes con Gestión', this.client_kpi_1.visitedClients_InRoute, this.client_kpi_1.visitedClients_OutRoute, this.client_kpi_1.visitedClients_Total]);

        footer = [];
        footer.push([
            {content:'% Cumplimiento con Planificación del Día', colSpan:3},
            this.client_kpi_1.percent
        ]);

        autoTable(doc, {head:header_kpis, body:x, foot: footer, headStyles:{fillColor:'#e9ecef', textColor:'#000'}, footStyles:{fillColor:'#e9ecef', textColor:'#000'}, theme:'grid'});

        //KPI 4
        x = [];
        //x.push(['# Visitas Total ER + FR', this.client_kpi_2.visitedClientsInRoute_InRoute, this.client_kpi_2.visitedClientsInRoute_OutRoute, this.client_kpi_2.visitedClientsInRoute_Total]);
        x.push(['Clientes con Gestión', this.client_kpi_2.visitedClientsInRoute_InRoute, this.client_kpi_2.visitedClientsInRoute_OutRoute, this.client_kpi_2.visitedClientsInRoute_Total]);
        x.push(['Clientes con Venta', this.client_kpi_2.visitedClientsOutRoute_InRoute, this.client_kpi_2.visitedClientsOutRoute_OutRoute, this.client_kpi_2.visitedClientsOutRoute_Total]);

        footer = [];
        footer.push([
            {content:'% Efectividad de Ventas del día', colSpan:3},
            this.client_kpi_2.percent
        ]);

        autoTable(doc, {head:header_kpis, body:x, foot: footer, headStyles:{fillColor:'#e9ecef', textColor:'#000'}, footStyles:{fillColor:'#e9ecef', textColor:'#000'}, theme:'grid'});

        //KPI 5
        x = [];
        //x.push(['# Visitas Total ER + FR', this.client_kpi_3.visitedClientsInRouteOutRoute_InRoute, this.client_kpi_3.visitedClientsInRouteOutRoute_OutRoute, this.client_kpi_3.visitedClientsInRouteOutRoute_Total]);
        x.push(['Clientes con Gestión', this.client_kpi_3.visitedClientsInRouteOutRoute_InRoute, this.client_kpi_3.visitedClientsInRouteOutRoute_OutRoute, this.client_kpi_3.visitedClientsInRouteOutRoute_Total]);
        x.push(['# Clientes con Pedido', this.client_kpi_3.saleToClient_InRoute, this.client_kpi_3.saleToClient_OutRoute, this.client_kpi_3.saleToClient_Total]);

        footer = [];
        footer.push([
            {content:'% Efectividad de Venta en la Ruta del Día', colSpan:3},
            this.client_kpi_3.percent
        ]);

        //autoTable(doc, {head:header_kpis, body:x, foot: footer, headStyles:{fillColor:'#e9ecef', textColor:'#000'}, footStyles:{fillColor:'#e9ecef', textColor:'#000'}, theme:'grid'});

        //KPI 6
        x = [];
        x.push(['# Clientes con Obj. Cobro', this.client_kpi_4.clientsGoalCollection_InRoute, this.client_kpi_4.clientsGoalCollection_OutRoute, this.client_kpi_4.clientsGoalCollection_Total]);
        x.push(['# Clientes con Cobro', this.client_kpi_4.clientsCollected_InRoute, this.client_kpi_4.clientsCollected_OutRoute, this.client_kpi_4.clientsCollected_Total]);

        footer = [];
        footer.push([
            {content:'% Efectividad de Cobro en la Ruta del Día', colSpan:3},
            this.client_kpi_4.percent
        ]);

        //autoTable(doc, {head:header_kpis, body:x, foot: footer, headStyles:{fillColor:'#e9ecef', textColor:'#000'}, footStyles:{fillColor:'#e9ecef', textColor:'#000'}, theme:'grid'});

        //KPI 7
        header_kpis = [['ITEM', 'CLIENTES', 'VISITAS', '% CUMPLIMIENTO']];

        x = [];
        x.push(['Ruta Planificada', this.client_kpi_5.plannedRoute_TotalClients, this.client_kpi_5.plannedRoute_VisitedClients, this.client_kpi_5.percent]);

        footer = [];
        footer.push([
            {content:'% Cumplimiento de Clientes Planificados en Ruta', colSpan:3},
            this.client_kpi_5.percent
        ]);

        //autoTable(doc, {head:header_kpis, body:x, foot: footer, headStyles:{fillColor:'#e9ecef', textColor:'#000'}, footStyles:{fillColor:'#e9ecef', textColor:'#000'}, theme:'grid'});
        

        //Page Header and Footer
        doc = this.addPagesHeaderAndFooter(doc);
        doc.save('cumplimiento_ruta_' + this.curr_date);
    }

    addPagesHeaderAndFooter(doc:any) {
        var totalPages = doc.internal.getNumberOfPages();

        for (let i = 1; i <= totalPages; i++) {
            doc.setPage(i);
            doc.addImage(Global.logo_base64, 'PNG', 710, 10, 90, 20);

            // Footer
            var str = 'Página ' + i + ' de ' + totalPages;
            doc.setFontSize(10);

            // jsPDF 1.4+ uses getWidth, <1.4 uses .width
            var pageSize = doc.internal.pageSize;
            var pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight();
            doc.text(str, 40, pageHeight - 10);
        }

        return doc;
    }

}
